import { FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

import { UserInvitationChannelType } from '@enums/user-invitation-channel-type.enum';
import { UserInvitationFeatureForm } from '@forms/user-invitation-feature-form';
import { UserInvitationConfiguration } from '@models/user-invitation-configuration';

export type UserInvitationConfigurationFormType = {
  features: UserInvitationFeatureForm;
  channels: FormControl<UserInvitationChannelType[]>;
  withFormation: FormControl<boolean>;
};

export class UserInvitationConfigurationForm extends FormGroup<UserInvitationConfigurationFormType> {
  get channels(): FormControl<UserInvitationChannelType[]> {
    return this.controls.channels;
  }

  get features(): UserInvitationFeatureForm {
    return this.controls.features;
  }

  get invoiceApp(): FormControl<boolean> {
    return this.controls.features.controls.invoiceApp;
  }

  get hasAllFeaturesSelected(): boolean {
    return this.invoiceApp.value && this.receiptApp.value;
  }

  get receiptApp(): FormControl<boolean> {
    return this.controls.features.controls.receiptApp;
  }

  constructor(featuresRequired = true) {
    super(
      {
        features: new UserInvitationFeatureForm(featuresRequired),
        channels: new FormControl<UserInvitationChannelType[]>([]),
        withFormation: new FormControl<boolean>(false)
      },
      { validators: [UserInvitationConfigurationForm.channelIsRequiredValidator()] }
    );
  }

  static channelIsRequiredValidator(): ValidatorFn {
    return (form: UserInvitationConfigurationForm): ValidationErrors | null => {
      if (
        ((form.features.controls.receiptApp.value ||
          form.features.controls.invoiceApp.value ||
          form.controls.withFormation.value) &&
          (form.channels.value ?? []).length === 0) ||
        ((form.channels.value ?? []).length &&
          !form.features.controls.receiptApp.value &&
          !form.features.controls.invoiceApp.value)
      ) {
        return { required: true };
      }

      return null;
    };
  }

  toUserInvitationConfiguration(): UserInvitationConfiguration {
    return new UserInvitationConfiguration(
      this.features.toUserInvitationFeatures(),
      this.channels.value,
      this.value.withFormation
    );
  }
}
